<template>
  <mobile-status-section
    :statuses="statuses"
    :records="records"
    show-ryg
  ></mobile-status-section>
</template>

<script>
import MobileStatusSection from "../../components/MobileStatusSection";
import CancelablePromise from "../../../../services/CancelablePromise";

export default {
  name: "ActivePipelineMobile",
  components: {MobileStatusSection},
  data() {
    return {
      pageLoading: false,
      reloadingPipelinePromise: null,
    };
  },
  watch: {
    // watches if user changes the value of Pipeline View option
    'pipelineViewId'() {
      // resets the record array to avoid duplicates
      this.$store.dispatch("activeState/tearDown");
      this.loadPipelineData()
    },
  },
  computed: {
    pipelineViewId() {
      return this.$store.getters["activeState/pipelineViewId"];
    },
    statuses() {
      return this.$store.getters["pipeline/activeStatusesInView"];
    },
    records() {
      return this.$store.getters["activeState/records"]
    }
  },
  created() {
    this.loadPipelineData()
  },
  destroyed() {
    this.$store.dispatch("activeState/tearDown");
  },
  methods: {
    async loadPipelineData() {
      this.pageLoading = true

      if (this.reloadingPipelinePromise) {
        this.reloadingPipelinePromise.cancel();
      }

      this.reloadingPipelinePromise = CancelablePromise(new Promise(async (resolve) => {
        for (let i=0; i < this.statuses.length; i++) {
          await this.$store.dispatch("activeState/setup", this.statuses[i].id).then(() => {});
        }

        this.pageLoading = false
        resolve();
      }))
    }
  }
};
</script>
